module.exports = function (number) {
    let validator =/^[^A-Za-z]*$/;
    return validator.test(number);
};
